// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home[data-v-5b685826] {\n  padding: 32px;\n  background-color: rgb(240, 242, 245);\n}\n.home .chart-wrapper[data-v-5b685826] {\n  background: #fff;\n  padding: 16px 16px 0;\n  margin-bottom: 32px;\n}", ""]);
// Exports
module.exports = exports;
